export const CLASS_NAMES = {
	delayed: "delayed",
	disabled: "disabled",
	hidden: "hidden",
	flightChangeSearchOutboundDateClass: "flight-change-search-outbound-date",
	flightChangeSearchReturnDateClass: "flight-change-search-return-date",
	flightChangeSearchPassengerSelectorClass: "flight-change-search-passenger-selector",
	invalid: "invalid",
};
